import EMPTY_FILTRO from './emptyFiltro'

const EMPTY_FILTRO_PROCESSO = (caixa) => {
  return {
    ...EMPTY_FILTRO(caixa),
    municipios: [],
    sps: [],
    responsavel: null,
    orgao: null
  }
}

export default EMPTY_FILTRO_PROCESSO



// WEBPACK FOOTER //
// ./src/libs/models/filtro/emptyFiltroProcesso.js